export const agnieszkaGuminska = {
    'meta': {
        'title': 'Psycholog dziecięcy Agnieszka Gumińska • Centrum COLLIGO',
        'description': 'Ukończyłam studia magisterskie z psychologii na SWPS w Sopocie. W pracy zajmuję się różnorodnymi zaburzeniami zachowania i emocji u dzieci i młodzieży.'
    },
    'url': {
        'address': '/torun/zespol/psycholog-dzieciecy-agnieszka-guminska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/agnieszka-guminska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog dziecięcy Agnieszka Gumińska'
        }
    }
}